export const OUTLOOK365 = 'o365';
export const MICROSOFT = 'MICROSOFT';
export const GOOGLE = 'GOOGLE';
export const APPLE = 'APPLE';
export const SSO = 'SSO';
export const UNKNOWN = 'UNKNOWN';
export const HUBSPOT = 'HUBSPOT';
export const PASSKEY = 'PASSKEY';
export const CHROME_EXTENSION = 'crx';